// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Component } from "react";

import PropTypes from "prop-types";

import { Button, ButtonsWrapper } from "components/elements";
import { Subsection, Accordion } from "components/layout";
import { Modal } from "components/modals";
import { trans } from "src/translations";
import {
  CONTINENT_WORLD,
  getContinentNames,
  getCountries,
  getCountriesForContinent,
} from "utils/continents";

import styles from "./RegionsPreviewModal.scss";

export class RegionsPreviewModal extends Component {
  static propTypes = {
    countries: PropTypes.object,
    isOpen: PropTypes.bool,
    onClose: PropTypes.bool,
  };

  static defaultProps = {
    countries: [],
  };

  getHeaderText(region, howMany, from) {
    let header;

    if (howMany === from) {
      header = `${region} (${trans.ALL()})`;
    } else {
      header = `${region} (${howMany}/${from})`;
    }

    return header;
  }

  renderCountryList(selectedCountries) {
    return (
      <ul className={styles.countryList}>
        {selectedCountries.map((country) => (
          <li key={country.name} className={styles.item}>
            {country.name}
          </li>
        ))}
      </ul>
    );
  }
  renderSubsections = () => {
    const { countries } = this.props;
    return getContinentNames().map((region) => {
      const allRegionCountries = getCountriesForContinent(
        getCountries(),
        region
      );
      const selectedCountries = allRegionCountries.filter((country) =>
        countries.includes(country.code)
      );

      return (
        <Subsection key={region}>
          <Accordion
            disabled={!selectedCountries.length}
            header={this.getHeaderText(
              region,
              selectedCountries.length,
              allRegionCountries.length
            )}
            longContent={region === CONTINENT_WORLD}
          >
            {this.renderCountryList(selectedCountries)}
          </Accordion>
        </Subsection>
      );
    });
  };

  render() {
    const { isOpen, onClose } = this.props;
    return (
      <Modal
        title={trans.TARGETS__REGIONS_MODAL_TITLE_READONLY()}
        isOpen={isOpen}
        onClose={onClose}
        actions={
          <ButtonsWrapper>
            <Button type="normal" onClick={onClose}>
              {trans.CANCEL()}
            </Button>
          </ButtonsWrapper>
        }
      >
        {this.renderSubsections()}
      </Modal>
    );
  }
}
